import React, {Component} from 'react';
import ContractFundingFrameworkContract from './ContractFundingFrameworkContract';
import ContractFundingKAE from './ContractFundingKAE';

export default class ContractFunding extends Component {
    constructor() {
        super();

        this.state = {
            funding_source: "",
            framework_contract_id: 0,
            kae_id: 0,
            article_amounts: []
        };

        this.handleFundingSourceChange = this.handleFundingSourceChange.bind(this);
    }

    componentWillMount() {
        this.setState({
            funding_source: this.props.fundingSource,
            framework_contract_id: this.props.frameworkContractId,
            kae_id: this.props.kaeId,
            article_amounts: this.props.articleAmounts,
        });
    }

    handleFundingSourceChange(e) {
        this.setState({
            funding_source: e.target.value
        });
    }

    render() {
        let funding_element = null;
        if (this.state.funding_source === "kae") {
            funding_element = <ContractFundingKAE
                kaeId={this.state.kae_id}
            />;
        } else if (this.state.funding_source === "framework_contract") {
            funding_element = <ContractFundingFrameworkContract
                frameworkContractId={this.state.framework_contract_id}
                articleAmounts={this.state.article_amounts}
            />;
        } else if (this.state.funding_source === "general_account_codes") {

        }

        const title = this.props.isExpenditure
            ? window.__js_contracts.expenditure_funding
            : window.__js_contracts.contract_funding;

        return (
            <div>
                <div className="row">
                    <div className="col-sm-offset-4 col-sm-8">
                        <legend>{title}</legend>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="funding_source" className="col-md-4 control-label">
                        {window.__js_contracts.funding_source}*
                    </label>
                    <div className="col-md-8">
                        <select name="funding_source"
                                id="funding_source"
                                className="form-control"
                                value={this.state.funding_source}
                                onChange={this.handleFundingSourceChange}>
                            <option value="resources">{window.__js_contracts.resources}</option>
                            <option value="kae">{window.__js_contracts.kae}</option>
                            <option value="framework_contract">{window.__js_contracts.framework_contract}</option>
                            <option value="general_account_codes">{window.__js_contracts.general_account_codes}</option>
                            <option value="european">{window.__js_contracts.european}</option>
                        </select>
                    </div>
                </div>
                <br/>
                {funding_element}
            </div>
        );
    }
}